import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { EnumStatisticChartType } from "../../../../../server/routes/statistic/types";
import MenuButton from "../../../components/MenuButton";
import { actionTypeChange } from "../../../store/statisticChart/actions";
import { useStatusGroup } from "../StatusGroupProvider";
import { SelectorTypeFC } from "./types";
import Grid from "@material-ui/core/Grid";

const SelectorType: SelectorTypeFC = ({loading}) => {
    const {statusGroup} = useStatusGroup();
    const {type, isLoading} = useSelector(
        ({
             statisticChart: {
                 [statusGroup]: {type, sending},
             },
         }) => ({type, isLoading: sending})
    );
    const dispatch = useDispatch();
    const handlerSelect = (type: EnumStatisticChartType) => {
        dispatch(actionTypeChange(statusGroup, type));
        loading({type});
    };
    const isSmallScreen = window.innerWidth < 600;

    return (
        isSmallScreen ?
                <MenuButton
                    ButtonProps={{
                        variant: "outlined",
                        color: "primary",
                        disabled: isLoading,
                        fullWidth: true,
                    }}
                    active={type}
                    items={[
                        {
                            label: "Выручка, руб",
                            code: EnumStatisticChartType.REVENUE,
                            onClick: handlerSelect.bind(null, EnumStatisticChartType.REVENUE),
                        },
                        {
                            label: "Маржинальность, руб",
                            code: EnumStatisticChartType.MARGINALITY_VALUTE,
                            onClick: handlerSelect.bind(
                                null,
                                EnumStatisticChartType.MARGINALITY_VALUTE
                            ),
                        },
                        {
                            label: "Маржинальность, %",
                            code: EnumStatisticChartType.MARGINALITY_PERCENT,
                            onClick: handlerSelect.bind(
                                null,
                                EnumStatisticChartType.MARGINALITY_PERCENT
                            ),
                        },
                        {
                            label: "Заказы, шт",
                            code: EnumStatisticChartType.ORDERS,
                            onClick: handlerSelect.bind(null, EnumStatisticChartType.ORDERS),
                        },
                    ]}
                />
                :
                <Grid item>
                    <div style={{marginTop: '8px', marginLeft: '10px'}}>
                        <MenuButton
                            ButtonProps={{
                                variant: "outlined",
                                color: "primary",
                                disabled: isLoading,
                            }}
                            active={type}
                            items={[
                                {
                                    label: "Выручка, руб",
                                    code: EnumStatisticChartType.REVENUE,
                                    onClick: handlerSelect.bind(null, EnumStatisticChartType.REVENUE),
                                },
                                {
                                    label: "Маржинальность, руб",
                                    code: EnumStatisticChartType.MARGINALITY_VALUTE,
                                    onClick: handlerSelect.bind(
                                        null,
                                        EnumStatisticChartType.MARGINALITY_VALUTE
                                    ),
                                },
                                {
                                    label: "Маржинальность, %",
                                    code: EnumStatisticChartType.MARGINALITY_PERCENT,
                                    onClick: handlerSelect.bind(
                                        null,
                                        EnumStatisticChartType.MARGINALITY_PERCENT
                                    ),
                                },
                                {
                                    label: "Заказы, шт",
                                    code: EnumStatisticChartType.ORDERS,
                                    onClick: handlerSelect.bind(null, EnumStatisticChartType.ORDERS),
                                },
                            ]}
                        />
                    </div>
                </Grid>
    );
};

export default SelectorType;
